//import axios from 'axios';
import http from './httpService';
const apiUrl = process.env.REACT_APP_API_URL;

const apiEndpoint = apiUrl + '/companies';

function userUrl(id) {
  return `${apiEndpoint}/${id}`;
}

export function getCompanys() {
  return http.get(apiEndpoint);
}

export function getCompanyByUser(id) {
  return http.get(`${apiEndpoint}/user/${id}`);
}

export function getCompany(userId) {
  return http.get(userUrl(userId));
}

export function saveCompany(user, imageSrc) {
  const formData = new FormData();
  //update
  if (user._id) {
    //clone user and delete _id
    const body = { ...user };
    delete body._id;
    for (let key in body) {
      formData.append(key, body[key]);
    }
    formData.append('imageSrc', imageSrc);
    return http.put(userUrl(user._id), formData);
  }
  const body = { ...user };
  for (let key in body) {
    formData.append(key, body[key]);
  }
  formData.append('imageSrc', imageSrc);
  //add a new user
  return http.post(apiEndpoint, formData);
}

export function patchCompany(user, imageSrc) {
  const formData = new FormData();
  //update
  if (user._id) {
    const body = { ...user };
    delete body._id;
    delete body.imageSrc;
    for (let key in body) {
      if (key === "languages") {
        formData.append("languages", JSON.stringify(body[key]));
      } else {
        if (key === "workingHours") {
          formData.append(key, JSON.stringify(body[key]));
        } else formData.append(key, body[key]);
      }
    }
    formData.append("imageSrc", imageSrc);
    return http.patch(userUrl(user._id), formData);
  }
}
//delete users
export function deleteCompany(userId) {
  return http.delete(userUrl(userId));
}  
